import React, { PureComponent, createRef } from 'react';
import { Card, Button, Typography, Row, Col, Space } from 'antd';
import SignaturePad from './SignaturePad';
import { useTranslation } from 'react-i18next';

const { Title } = Typography;

class SignaturePadContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.signaturePadRef = props.signaturePadRef;
  }

  handleClear() {
    const signaturePad = this.signaturePadRef.current;
    if (signaturePad) {
      signaturePad.instance.clear();
    }
  }


  renderTitle() {
    return (
      <Row justify="center" style={{ marginBottom: 20 }}>
        <Col>
          <Title level={2}>React-Signature-Pad-Wrapper</Title>
          <Title level={4} type="secondary">Responsive Example</Title>
        </Col>
      </Row>
    );
  }

  renderSignaturePad() {
    const { t } = this.props; 
    return (
    <>
      <Row justify="center">
        <Col xs={24} sm={20} md={16} lg={12}>
          <Card
            title="Please sign below"
            actions={[
              <Button key="clear" type="text" onClick={() => this.handleClear()}>{t('eSignature.clear')}</Button>,
              // <Button key="save" type="text" onClick={() => this.handleSave()}>Save</Button>,
            ]}
            styles={{ body: { padding: 0 } }}
          >
            <SignaturePad redrawOnResize ref={this.signaturePadRef} />
          </Card>
        </Col>
      </Row>
      <Row style={{marginTop: '10px', fontSize:'12px', fontWeight:'500'}}>
        {t('eSignature.agreementText')}
      </Row>
    </>
    );
  }

  render() {
    return (
      <div style={{}}>
        {/* {this.renderTitle()} */}
        {this.renderSignaturePad()}
      </div>
    );
  }
}

export default function SignaturePadWrapper(props) {
  const { t } = useTranslation();
  return <SignaturePadContainer {...props} t={t} />;
}
